import AppRouters from './infrastructure/routes/AppRouters';

const App = () => {
  return <AppRouters />;
};

export default App;
